import type { Movie } from "@/lib/movies-data";
import { PosterCard } from "./PosterCard";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useRef } from "react";
import { useTheme } from "@/lib/theme-context";
export function PosterRow({ title, subtitle, movies }: { title: string; subtitle?: string; movies: Movie[] }) {
  const ref = useRef<HTMLDivElement>(null);
  const { dir, language } = useTheme();
  const scroll = (d: 1 | -1) => {
    const factor = dir === "rtl" ? -d : d;
    ref.current?.scrollBy({ left: factor * 600, behavior: "smooth" });
  };
  const isAr = dir === "rtl";
  if (!movies || movies.length === 0) {
    return (
      <section className="py-8">
        <div className="container mx-auto px-4">
          <div className="mb-4">
            <h2 className="text-2xl md:text-3xl font-extrabold">{title}</h2>
            {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
          </div>
          <div className="flex gap-4 overflow-hidden">
            {Array.from({ length: 6 }).map((_, i) => (
              <div
                key={i}
                className="shrink-0 w-[160px] sm:w-[180px] md:w-[200px] aspect-[2/3] rounded-xl bg-muted/40 animate-pulse"
                aria-hidden
              />
            ))}
            <span className="sr-only">{(language === "ar" ? "\u062c\u0627\u0631\u064a \u0627\u0644\u062a\u062d\u0645\u064a\u0644" : language === "fr" ? "Chargement" : "Loading")}</span>
          </div>
        </div>
      </section>
    );
  }
  return (
    <section className="py-8">
      <div className="container mx-auto px-4">
        <div className="flex items-end justify-between mb-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-extrabold">{title}</h2>
            {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
          </div>
          <div className="hidden sm:flex gap-1">
            <button onClick={() => scroll(-1)} className="p-2 rounded-lg bg-card hover:bg-accent transition" aria-label="Prev">
              <ChevronLeft className="h-5 w-5" />
            </button>
            <button onClick={() => scroll(1)} className="p-2 rounded-lg bg-card hover:bg-accent transition" aria-label="Next">
              <ChevronRight className="h-5 w-5" />
            </button>
          </div>
        </div>
        <div ref={ref} className="PrRow flex gap-4 overflow-x-auto pb-3 snap-x snap-mandatory scroll-smooth -mx-4 px-4">
          {movies.map((m) => (
            <div key={m.id} className="shrink-0 w-[160px] sm:w-[180px] md:w-[200px] snap-start">
              <PosterCard movie={m} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
